var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/FilterBlock/FilterBlock.less";
// imported only for typings
// these are passed to the component from index.ts
import { Carousel, CarouselItem } from "./components";
var FilterBlock = /** @class */ (function (_super) {
    __extends(FilterBlock, _super);
    function FilterBlock(props) {
        return _super.call(this, props) || this;
    }
    FilterBlock.prototype.render = function () {
        var _this = this;
        var className = this.props.state.isEventView ? "rj-filter-block--side-panel" : "";
        var config = __assign({}, this.props.config, { iconSize: this.props.state.isEventView ? "24" : this.props.config.iconSize });
        return (React.createElement("div", { className: className },
            React.createElement(Carousel, null, this.props.state.Items.map(function (item, index) {
                return React.createElement(CarouselItem, { key: "item-" + index, item: item, config: config, handler: function () { return _this.props.state.selectItem(item); }, isSelected: _this.props.state.SelectedItemId === item.id });
            }))));
    };
    FilterBlock = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], FilterBlock);
    return FilterBlock;
}(React.Component));
export { FilterBlock };
//# sourceMappingURL=FilterBlock.js.map